import { BounceZoomIn, BounceZoomOut } from "slotworks/graphics/animation/base-animations";
import Layers from "slotworks/graphics/layers/layers";
import { AbstractSceneTransition } from "slotworks/graphics/layers/scene-transitions/abstract-scene-transition";
import Contract from "slotworks/utils/contract";
import settingsModel from "slotworks/model/settings/settings-model";
import gameState from "slotworks/model/game-state";

export default class LineWinTransitions extends AbstractSceneTransition {

    private BOUNCE_TIME: number = 300;
    private noWinWin: boolean;

    public in(): Contract<void> {
        return new Contract((resolve) => {
            this.noWinWin = settingsModel.isUKJurisdiction() && !gameState.getCurrentGame().isWinAboveBet();
            if(this.noWinWin) {
                this.formatLowWinText();
                resolve(null);
            } else 
                BounceZoomIn(Layers.CelebrationContent.getSprite("value"), this.BOUNCE_TIME, 0).then(resolve);
        });
    }

    public out(): Contract<void> {
        return new Contract((resolve) => {
            if(this.noWinWin)
                resolve(null);
            else 
                BounceZoomOut(Layers.CelebrationContent.getSprite("value"), this.BOUNCE_TIME, 0).then(resolve);
        });
    }

    private formatLowWinText() {
        const text = Layers.CelebrationContent.getSprite("value");
        const scale = text.scale.x * 0.6;
        text.scale.set(scale, scale);
        text.tint = 0xcccccc;
    }

}



// WEBPACK FOOTER //
// ./~/ifdef-loader/ifdef-loader.js??ref--0-1!./~/slotworks/integration/revolver/transitions/line-win-transitions.ts